<template>
    <div :class="routeName == 'Microgrid'? 'power power1':'power'" >
        <Title firstName="发电总功率" lastName="TOTAL GENERATING POWER"/>
        <div class="echarts">
            <div class="edata">
                <div class="edataCon">
                    <p>实时总功率</p>
                    <p>{{seriesData[seriesData.length - 1] || 0}}<span> kVA</span></p>

                </div>
                <div class="edataCon">
                    <p>装机容量</p>
                    <p>120<span> kWp</span></p>

                </div>
            </div>
            <div class="eview">
               <charts id="Microgrid" :series="seriesOption" :xData="xData"></charts>
                <!-- <Graph :chartId="chartId" :seriesData="seriesData1" :seriesData1="seriesData" :xData="xData" v-if="seriesData.length >0"/>
                <div class="icon"><span></span> 今日 <span></span> 昨日</div> -->
            </div>
            <div class="bottom"></div>
        </div>
    </div>
</template>

<script>
const Title = () => import('../../../../components/title/Title.vue')
const Graph = () => import('../../../../components/echarts/graph.vue')
const charts = () => import("../../../../components/echarts/charts.vue");
export default {
    data(){
        return {
            chartId:'power',
            xData:['00:00', '01:00', '02:00', '03:00', '04:00', '05:00', '06:00','07:00','08:00','09:00','10:00','11:00','12:00','13:00','14:00','15:00','16:00','17:00','18:00','19:00','20:00','21:00','22:00','23:00','24:00',],
            seriesData:[],
            seriesData1:[],
            seriesOption:[],
            xData:[]
        }
    },
    components:{
        Title,Graph,charts
    },
    mounted(){
        this.xData = []
        for(let i = 0; i <= 24; i++){
            this.xData.push((i<10?'0'+i:i)+':00')
        }
        this.getPower()
    },
    methods:{
        getPower(){
            if(this.weather.indexOf('阴') != -1 || this.weather.indexOf('云') != -1 || this.weather.indexOf('雨') != -1){

                let seriesData = [0, 0, 0, 0, 0, 0, 10.11, 11.23, 23.71, 45.64, 50.22, 70.54, 95.23, 96.11, 95.32, 95.20, 84.11, 50.44, 30.21, 0, 0, 0, 0, 0]
                let time = new Date()
                let hour = time.getHours() + 1
                let arr = seriesData.splice(0,hour)
                this.seriesData = arr
                this.seriesData1 = [0, 0, 0, 0, 0, 0, 10.11, 11.23, 23.71, 45.64, 65.22, 80.54, 108.23, 108.11, 105.32, 100.20, 94.11, 60.44, 30.21, 0, 0, 0, 0, 0]
            }else{

                let seriesData = [0, 0, 0, 0, 0, 0, 10.11, 11.23, 23.71, 45.64, 65.22, 80.54, 108.23, 108.11, 105.32, 100.20, 94.11, 60.44, 30.21, 0, 0, 0, 0, 0]
                let time = new Date()
                let hour = time.getHours() + 1
                let arr = seriesData.splice(0,hour)
                this.seriesData = arr
                this.seriesData1 = [0, 0, 0, 0, 0, 0, 10.11, 11.23, 23.71, 45.64, 50.22, 70.54, 95.23, 96.11, 95.32, 95.20, 84.11, 50.44, 30.21, 0, 0, 0, 0, 0]
            }
             this.seriesOption = [{


                 
                name:"今日",
                type:"line",
                data:this.seriesData
            },{
                name:"昨日",
                type:"line",
                data:this.seriesData1
            }]
        }
    },
    watch:{
        '$store.state.Cang.weather'(weather){
            console.log(weather);
            if(weather.indexOf('阴') != -1 || weather.indexOf('云') != -1 || this.weather.indexOf('雨') != -1){
                this.$nextTick(()=>{
                    let seriesData = [0, 0, 0, 0, 0, 0, 10.11, 11.23, 23.71, 45.64, 50.22, 70.54, 95.23, 96.11, 95.32, 95.20, 84.11, 50.44, 30.21, 0, 0, 0, 0, 0]
                    let time = new Date()
                    let hour = time.getHours() + 1
                    let arr = seriesData.splice(0,hour)
                    this.seriesData = arr
                    this.seriesData1 = [0, 0, 0, 0, 0, 0, 10.11, 11.23, 23.71, 45.64, 65.22, 80.54, 108.23, 108.11, 105.32, 100.20, 94.11, 60.44, 30.21, 0, 0, 0, 0, 0]

                })
            }else{
                let seriesData = [0, 0, 0, 0, 0, 0, 10.11, 11.23, 23.71, 45.64, 65.22, 80.54, 108.23, 108.11, 105.32, 100.20, 94.11, 60.44, 30.21, 0, 0, 0, 0, 0]
                let time = new Date()
                let hour = time.getHours() + 1
                let arr = seriesData.splice(0,hour)
                this.seriesData = arr
                this.seriesData1 = [0, 0, 0, 0, 0, 0, 10.11, 11.23, 23.71, 45.64, 50.22, 70.54, 95.23, 96.11, 95.32, 95.20, 84.11, 50.44, 30.21, 0, 0, 0, 0, 0]

            }
        }
    },
    computed:{
        routeName() {
            return this.$route.query.name;
        },
        weather(){
            return this.$store.state.Cang.weather
        }
    }
}
</script>

<style lang="less" scoped>
    .power{
        height: 33.3vh;
        width: 20vw;
        position: fixed;
        top: 64.4vh;
        left: 2vw;
        z-index: 1;

        .echarts{
            position: relative;
            height: 28.7vh;
            padding-bottom: 1vh;
            background:  linear-gradient(0deg, rgba(0, 33, 59, 0.6) 0%, rgba(3, 13, 24, 0.7) 100%);

            .edata{
                height: 9vh;
                display: flex;
                justify-content: space-around;
                padding: 3vh 0;
                .edataCon{
                    position: relative;
                    text-align: center;
                    p:nth-child(1){
                        font-size: 14rem;
                        font-family: Source Han Sans CN;
                        font-weight: 400;
                        color: rgba(230,243,253, 0.7);
                    }
                    p:nth-child(2){
                        padding-top: 3rem;
                        font-size: 20rem;
                        font-family: zcoolqingkehuangyouti;
                        font-weight: 400;
                        color: #00DEFF;
                        span{
                            font-size: 14rem;
                        }
                    }

                }
            }

            .eview{
                padding: 0 0.5vw;
                height: 17.9vh;
                position: relative;

                .icon{
                    position: absolute;
                    right: 1vw;
                    top: 0;
                    color: rgba(230,243,253, 0.7);
                    &>span{
                        width: 12rem;
                        height: 12rem;
                        display: inline-block;
                        vertical-align: -1rem;
                        margin-right: 5rem;
                    }
                    &>span:nth-of-type(1){
                        background-color: #f6bd16;
                    }
                    &>span:nth-of-type(2){
                        background-color: #1290ff;
                        margin-left: 5rem;
                    }
                }
            }

            .bottom{
                width: 20vw;
                height: 1vh;
                background: url(../../../../assets/img/板块装饰线.png) no-repeat;
                block-size: 100% 100%;
                position: absolute;
                bottom: 0;
                left: 0;
            }
        }
    }
    .power1{
        top: 30.3vh;
    }

</style>